// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyCAsi3TUo6FY7qMufSAHJ00ptwEeJNLLzA",
    authDomain: "arw-ps-trendaviation.firebaseapp.com",
    projectId: "arw-ps-trendaviation",
    storageBucket: "arw-ps-trendaviation.appspot.com",
    messagingSenderId: "722262402717",
    appId: "1:722262402717:web:242a102993c9e89dfc5674"
  },


  production: true,
  api_base_url: 'https://api.arw-trendaviation.avitium.de:443/api/',
  // web version: replace api with web
  // mobile: replace api with mobile



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
